import { Injector, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AssociationController } from 'src/features/common/association/association.controller';
import { ApiHelper } from 'cad/common/services/api/api-helper';
import { AssociationApi } from 'src/features/common/association/association-api';

@Injectable()
export class PhysicalLocationAdjacentLocationsApi implements AssociationApi {
  private readonly endpoint: string = 'physical/location/';
  private readonly suffix: string = '/adjacent-locations';

  static createAssociationApi(
    apiHelper: ApiHelper,
    associationController: AssociationController,
    injector: Injector,
  ): AssociationApi {
    return new PhysicalLocationAdjacentLocationsApi(apiHelper);
  }

  constructor(
    private apiHelper: ApiHelper,
  ) {}

  public findAll = (pointCd: number | string): Observable<any> => {
    return this.apiHelper.request(this.endpoint + pointCd + this.suffix);
  }
}
